import { render, staticRenderFns } from "./InsurerListSideMenu.vue?vue&type=template&id=04ceda9a&scoped=true"
import script from "./InsurerListSideMenu.vue?vue&type=script&lang=js"
export * from "./InsurerListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ceda9a",
  null
  
)

export default component.exports